<template>
  <button @click="tap" class="py-4 text-lg font-bold w-full rounded-lg" :class="buttonClass">
    {{ label }}
  </button>
</template>

<script>
export default {
  props: ['label', 'isWhite'],
  data () {
    return {
      buttonClass: {
        'bg-black': !this.isWhite,
        'text-white': !this.isWhite,
        'border border-grey': this.isWhite
      }
    }
  },
  watch: {
    isWhite: function (newValue, oldValue) {
      this.buttonClass = {
        'bg-black': !this.isWhite,
        'text-white': !this.isWhite,
        'border border-grey': this.isWhite
      }
    }
  },
  methods: {
    tap () {
      this.$emit('click')
    }
  }
}
</script>

